module.exports = __webpack_public_path__ + "static/media/pdfIcon.e274ed9a.png";